import { render, staticRenderFns } from "./LoyaltyProgramForm.vue?vue&type=template&id=61c87bd4&scoped=true"
import script from "./LoyaltyProgramForm.vue?vue&type=script&lang=js"
export * from "./LoyaltyProgramForm.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyProgramForm.vue?vue&type=style&index=0&id=61c87bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c87bd4",
  null
  
)

export default component.exports